import React from 'react';
import { Link } from 'react-router-dom';
import './OutlinedButton.css';

interface OutlinedButtonProps {
  to: string;
  children: React.ReactNode;
  className?: string;
}

const OutlinedButton: React.FC<OutlinedButtonProps> = ({ to, children, className = '' }) => {
  return (
    <Link to={to} className={`outlined-button ${className}`}>
      {children}
    </Link>
  );
};

export default OutlinedButton;
